import React from "react";
import ObjectivesSection from "../Home/ObjectivesSection.jsx";

const ObjectivesPage = () => <ObjectivesSection />;

export default ObjectivesPage;
